import React, { useEffect, useState, useContext } from "react";
import LessonItem from "./LessonItem";
import FirebaseContext from "../firebase/firebaseContext";
import EventContext from "../event/eventContext";
import { Link } from "react-router-dom";
const Lesson = props => {
  const [id, setId] = useState(null);
  const eventContext = useContext(EventContext);
  const { homework } = eventContext;

  useEffect(() => {
    setId(props.match.params.lesson_id);
  });

  let homeworkToDisplay;
  if (homework === null) {
    homeworkToDisplay = (
      <div className='event-list'>
        <div className='naloge-container'>
          <h1 className='heading-error'>
            Osvežil/-a si stran. Ponovno naloži naloge
          </h1>

          <Link to='/naloge'>
            <button>Naloge</button>
          </Link>
        </div>
      </div>
    );
  } else if (homework.length === 0) {
    homeworkToDisplay = (
      <div className='naloge-container'>
        <h1>Učna ura še ni dodana. Vrni se kasneje.</h1>
      </div>
    );
  } else {
    homeworkToDisplay = homework.map(hw => {
      if (hw.id === id) return <LessonItem hw={hw} />;
    });
  }
  return (
    <section>
      <div className='naloga-banner'></div>

      {homeworkToDisplay}
    </section>
  );
};

export default Lesson;
